/* MACBOOT EXPEDIÇÃO — global.js */
(function () {
  'use strict';

  var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  var bfVariantMap = null;
  var bfMapPromise = null;

  function bfPhaseHost() { return document.querySelector('[data-bf-phases]'); }
  function superBlackIsReadyAndActive() {
    var host = bfPhaseHost();
    var phase = host && host.querySelector('[data-bf-phase="superBlack"]');
    return Boolean(host && host.dataset.superBlackReady === 'true' && phase && !phase.hidden);
  }
  function applyBfNavigation() {
    var active = superBlackIsReadyAndActive();
    document.querySelectorAll('[data-bf-super-navigation]').forEach(function (link) { link.hidden = !active; });
  }
  function primaryBfIsReadyAndActive() {
    var host = bfPhaseHost();
    if (!host) return false;
    return [['superBlack', 'superBlackReady'], ['progressive', 'progressiveReady']].some(function (entry) {
      var phase = host.querySelector('[data-bf-phase="' + entry[0] + '"]');
      return host.dataset[entry[1]] === 'true' && phase && !phase.hidden;
    });
  }
  function loadBfVariantMap() {
    if (bfVariantMap) return Promise.resolve(bfVariantMap);
    if (bfMapPromise) return bfMapPromise;
    var host = bfPhaseHost();
    if (!host || host.dataset.superBlackReady !== 'true' || !host.dataset.variantMapUrl) return Promise.resolve(null);
    bfMapPromise = fetch(host.dataset.variantMapUrl, { credentials: 'same-origin' })
      .then(function (response) { if (!response.ok) throw new Error('Super Black indisponível'); return response.json(); })
      .then(function (map) {
        Object.keys(map).forEach(function (id) {
          var percent = Number(map[id]);
          if (!/^\d+$/.test(id) || !Number.isInteger(percent) || percent < 1 || percent > 100) throw new Error('Mapa Super Black inválido');
        });
        bfVariantMap = map;
        document.dispatchEvent(new CustomEvent('mb:bf-variant-map-ready'));
        return map;
      })
      .catch(function () { bfMapPromise = null; return null; });
    return bfMapPromise;
  }
  function bfTargetCents(priceCents, compareCents, percent) {
    var reference = Math.max(priceCents, compareCents || 0);
    return Math.min(priceCents, Math.round(reference * (100 - percent) / 100));
  }
  function applyBfCards() {
    var active = superBlackIsReadyAndActive();
    applyBfNavigation();
    if (!active) {
      document.querySelectorAll('[data-bf-card]').forEach(function (card) {
        var priceNode = card.querySelector('[data-bf-card-price]');
        var compareNode = card.querySelector('[data-bf-card-compare]');
        var installment = card.querySelector('[data-bf-card-installment]');
        var badge = card.querySelector('.p-badge.off');
        if (priceNode && priceNode.dataset.bfOriginalText !== undefined) priceNode.textContent = priceNode.dataset.bfOriginalText;
        if (compareNode && compareNode.dataset.bfOriginalText !== undefined) {
          compareNode.textContent = compareNode.dataset.bfOriginalText;
          compareNode.hidden = compareNode.dataset.bfOriginalHidden === 'true';
        }
        if (installment && installment.dataset.bfOriginalText !== undefined) installment.textContent = installment.dataset.bfOriginalText;
        if (badge && badge.dataset.bfGenerated === 'true') badge.remove();
        else if (badge && badge.dataset.bfOriginalText !== undefined) badge.textContent = badge.dataset.bfOriginalText;
      });
      return;
    }
    loadBfVariantMap().then(function (map) {
      if (!map || !superBlackIsReadyAndActive()) return;
      document.querySelectorAll('[data-bf-card]').forEach(function (card) {
        var data = card.querySelector('[data-bf-card-variants]');
        var priceNode = card.querySelector('[data-bf-card-price]');
        if (!data || !priceNode) return;
        if (priceNode.dataset.bfOriginalText === undefined) priceNode.dataset.bfOriginalText = priceNode.textContent;
        var compareNode = card.querySelector('[data-bf-card-compare]');
        if (compareNode && compareNode.dataset.bfOriginalText === undefined) {
          compareNode.dataset.bfOriginalText = compareNode.textContent;
          compareNode.dataset.bfOriginalHidden = String(compareNode.hidden);
        }
        var installment = card.querySelector('[data-bf-card-installment]');
        if (installment && installment.dataset.bfOriginalText === undefined) installment.dataset.bfOriginalText = installment.textContent;
        var variants;
        try { variants = JSON.parse(data.textContent).variants; } catch (error) { return; }
        var prices = variants.filter(function (variant) { return variant.available && Object.prototype.hasOwnProperty.call(map, String(variant.id)); }).map(function (variant) {
          var percent = Number(map[String(variant.id)]);
          return { price: Number(variant.price), reference: Math.max(Number(variant.price), Number(variant.compare || 0)), target: bfTargetCents(Number(variant.price), Number(variant.compare || 0), percent) };
        });
        if (!prices.length) return;
        var selected = prices.reduce(function (best, current) { return current.target < best.target ? current : best; });
        priceNode.textContent = money(selected.target);
        if (compareNode) {
          if (selected.reference > selected.target) { compareNode.textContent = money(selected.reference); compareNode.hidden = false; }
          else compareNode.hidden = true;
        }
        var badge = card.querySelector('.p-badge.off');
        if (selected.reference > selected.target) {
          if (!badge) { badge = document.createElement('span'); badge.className = 'p-badge off'; badge.dataset.bfGenerated = 'true'; card.querySelector('.p-media').prepend(badge); }
          else if (badge.dataset.bfOriginalText === undefined) badge.dataset.bfOriginalText = badge.textContent;
          badge.textContent = '−' + Math.round((selected.reference - selected.target) * 100 / selected.reference) + '% OFF';
        } else if (badge) badge.remove();
        if (installment) installment.textContent = '8x de ' + money(Math.floor(selected.target / 8)) + ' sem juros';
      });
    });
  }
  document.addEventListener('mb:bf-phase-change', applyBfCards);
  document.addEventListener('mb:bf-variant-map-ready', applyBfCards);
  applyBfCards();

  function money(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  function setCartCount(n) {
    document.querySelectorAll('.cart-n').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? 'grid' : 'none';
    });
  }

  function flashSaleData() {
    var el = document.getElementById('FlashSaleJson');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (error) { return null; }
  }

  function syncFlashDiscounts(cart, codePrefix) {
    if (!codePrefix) return Promise.resolve(cart);
    var current = (cart.discount_codes || []).map(function (item) { return item.code; }).filter(Boolean);
    var remaining = current.filter(function (code) { return code.indexOf(codePrefix) !== 0; });
    if (remaining.length === current.length) return Promise.resolve(cart);
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: remaining.join(',') })
    }).then(function (response) { if (!response.ok) throw new Error(); return response.json(); });
  }

  function migrateLegacyFlashDiscounts(codePrefix) {
    if (!/^\/cart\/?$/.test(window.location.pathname)) return;
    fetch(root + 'cart.js')
      .then(function (response) { if (!response.ok) throw new Error(); return response.json(); })
      .then(function (cart) {
        var hasFlashItem = (cart.items || []).some(function (item) {
          return item.properties && item.properties._mb_flash_campaign === 'ofertas-relampago-macboot-7f4c9a82b6';
        });
        var hasLegacyCode = (cart.discount_codes || []).some(function (item) {
          return item.code && item.code.indexOf(codePrefix) === 0;
        });
        if (!hasFlashItem || !hasLegacyCode) return cart;
        return syncFlashDiscounts(cart, codePrefix).then(function (updatedCart) {
          window.location.reload();
          return updatedCart;
        });
      })
      .catch(function () {});
  }

  function addFlashItem(variantId, quantity, code, data) {
    var properties = data.kind === 'customerLive'
      ? { _mb_live_cliente: '202609' }
      : { _mb_flash_campaign: data.campaign };
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: Number(quantity || 1), properties: properties })
    })
      .then(function (response) { if (!response.ok) throw new Error(); return fetch(root + 'cart.js'); })
      .then(function (response) { return response.json(); })
      .then(function (cart) { return syncFlashDiscounts(cart, data.codePrefix); });
  }

  migrateLegacyFlashDiscounts('MBOR7F4C-');

  /* ============ GERAL ============ */

  /* marquees */
  document.querySelectorAll('[data-marquee]').forEach(function (t) { t.innerHTML += t.innerHTML; });

  /* scroll reveal */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); });
  }

  /* FAQ accordion */
  document.querySelectorAll('.faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.closest('.faq-item');
      var a = item.querySelector('.faq-a');
      var open = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(function (o) {
        o.classList.remove('open');
        o.querySelector('.faq-a').style.maxHeight = null;
      });
      if (!open) { item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
    });
  });

  /* copiar cupom */
  document.querySelectorAll('[data-copy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (navigator.clipboard) navigator.clipboard.writeText(btn.getAttribute('data-copy')).catch(function () {});
      var old = btn.textContent;
      btn.textContent = 'Copiado!';
      setTimeout(function () { btn.textContent = old; }, 1800);
    });
  });

  /* drawer mobile */
  var drawer = document.getElementById('MobileDrawer');
  var burger = document.querySelector('.burger');
  if (drawer && burger) {
    /* O painel do menu ocupa a tela inteira, mas a página rolava atrás dele — todos os
       outros overlays do tema (busca, filtros, lightbox, tabela de medidas) travam o body.
       A trava segue a classe 'open' e nunca é setada solta: introduzir uma trava sem esse
       acoplamento é exatamente o que travou o filtro de coleção e o de busca. */
    var syncDrawerLock = function () {
      document.body.style.overflow = drawer.classList.contains('open') ? 'hidden' : '';
    };
    var closeDrawer = function () { drawer.classList.remove('open'); syncDrawerLock(); };
    burger.addEventListener('click', function () { drawer.classList.add('open'); syncDrawerLock(); });
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer || e.target.closest('.drawer-close') || e.target.closest('a')) closeDrawer();
    });
    /* válvulas de escape: com a trava ligada, qualquer caminho que feche o menu sem
       destravar deixaria a pessoa presa. */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer();
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 899) drawer.classList.remove('open');
      syncDrawerLock();
    });
    syncDrawerLock();
  }

  /* quick add (cards) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    btn.textContent = 'Adicionando…';
    var isFlash = btn.getAttribute('data-flash-sale') === '1';
    var flash = isFlash ? {
      campaign: 'ofertas-relampago-macboot-7f4c9a82b6',
      codePrefix: 'MBOR7F4C-'
    } : null;
    var request = isFlash
      ? addFlashItem(btn.getAttribute('data-quick-add'), 1, btn.getAttribute('data-flash-code'), flash)
      : fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(btn.getAttribute('data-quick-add')), quantity: 1 })
        })
          .then(function (r) { if (!r.ok) throw new Error(); return fetch(root + 'cart.js'); })
          .then(function (r) { return r.json(); });
    request
      .then(function (cart) {
        setCartCount(cart.item_count);
        btn.textContent = '✓ Adicionado';
        if (isFlash) window.location.assign(root + 'cart');
        else setTimeout(function () { btn.textContent = '+ Adicionar à sacola'; }, 1800);
      })
      .catch(function () {
        btn.textContent = 'Erro: tentar de novo';
        setTimeout(function () { btn.textContent = '+ Adicionar à sacola'; }, 2200);
      });
  });
    /* recomendações (PDP + carrinho) — section rendering */
  document.querySelectorAll('[data-recommendations]').forEach(function (sec) {
    fetch(sec.getAttribute('data-url'))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations]');
        if (fresh && fresh.innerHTML.trim()) {
          sec.innerHTML = fresh.innerHTML;
          sec.querySelectorAll('.rv').forEach(function (el) { el.classList.add('in'); });
          applyBfCards();
        }
      })
      .catch(function () {});
  });

  /* ============ PDP ============ */
  var pdp = document.querySelector('[data-pdp]');
  if (pdp) initPdp(pdp);

  function initPdp(scope) {
    var dataEl = document.getElementById('ProductJson');
    var product = dataEl ? JSON.parse(dataEl.textContent) : null;
    var flash = flashSaleData();
    var form = scope.querySelector('[data-product-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var buyBtn = form ? form.querySelector('[data-buy]') : null;
    var buyLabel = buyBtn ? ((buyBtn.getAttribute('data-buy-label') || buyBtn.textContent).trim()) : 'Adicionar à sacola';

    /* galeria */
    var mainImg = scope.querySelector('[data-main-image]');
    var pdpVideos = scope.querySelectorAll('.pdp-video');
    function pdpHideVideos() {
      pdpVideos.forEach(function (box) { box.hidden = true; var v = box.querySelector('video'); if (v) { try { v.pause(); } catch (e) {} } });
    }
    scope.querySelectorAll('.pdp-thumbs button').forEach(function (th) {
      th.addEventListener('click', function () {
        scope.querySelectorAll('.pdp-thumbs button').forEach(function (b) { b.classList.remove('cur'); });
        th.classList.add('cur');
        var type = th.getAttribute('data-type');
        if (type === 'video' || type === 'external_video' || type === 'model') {
          pdpHideVideos();
          var box = scope.querySelector('.pdp-video[data-media-id="' + th.getAttribute('data-media-id') + '"]');
          if (box) { box.hidden = false; var v = box.querySelector('video'); if (v) { v.play().catch(function () { v.muted = true; v.play().catch(function () {}); }); } }
        } else {
          pdpHideVideos();
          if (mainImg) { mainImg.srcset = ''; mainImg.src = th.getAttribute('data-src'); }
        }
      });
    });

    /* lightbox */
    var lb = scope.querySelector('[data-lightbox]');
    var lbImg = scope.querySelector('[data-lightbox-img]');
    var lbOpen = scope.querySelector('[data-lightbox-open]');
    if (lb && lbOpen) {
      lbOpen.addEventListener('click', function (e) {
        if (e.target.closest('.pdp-video')) return;
        if (mainImg) lbImg.src = mainImg.src;
        lb.hidden = false;
        document.body.style.overflow = 'hidden';
      });
      lb.addEventListener('click', function (e) {
        if (e.target === lb || e.target.closest('[data-lightbox-close]')) {
          lb.hidden = true;
          document.body.style.overflow = '';
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !lb.hidden) { lb.hidden = true; document.body.style.overflow = ''; }
      });
    }

    /* qty +/- */
    if (form) {
      var qty = form.querySelector('input[name="quantity"]');
      form.querySelectorAll('[data-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          qty.value = Math.max(1, Number(qty.value || 1) + Number(b.getAttribute('data-qty')));
        });
      });
    }

    if (form && flash) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var variantId = Number(idInput && idInput.value);
        if (!variantId) return;
        var qtyInput = form.querySelector('input[name="quantity"]');
        var quantity = qtyInput ? Number(qtyInput.value || 1) : 1;
        var code = flash.variantCodes && flash.variantCodes[String(variantId)];
        if (buyBtn) { buyBtn.disabled = true; buyBtn.textContent = 'Aplicando oferta…'; }
        addFlashItem(variantId, quantity, code, flash)
          .then(function (cart) { setCartCount(cart.item_count); window.location.assign(root + 'cart'); })
          .catch(function () {
            if (buyBtn) { buyBtn.disabled = false; buyBtn.textContent = 'Tentar novamente'; }
          });
      });
    }

    /* estado da variante */
    var lowstockEl = scope.querySelector('[data-lowstock]');
    var bis = scope.querySelector('[data-bis]');
    var stickyPrice = scope.querySelector('[data-sticky-price]');
    var stickySelect = scope.querySelector('[data-sticky-variant]');
    var pixEl = scope.querySelector('[data-pix]');
    var bfNote = scope.querySelector('[data-bf-pdp-note]');
    var cashbackBox = scope.querySelector('[data-pdp-cashback]');
    var cashbackTimer = null;
    var cashbackPrice = Number(cashbackBox && cashbackBox.getAttribute('data-price-cents'));
    var cashbackAvailable = true;
    function cashbackWindowIsActive() {
      if (!cashbackBox) return false;
      var percent = Number(cashbackBox.getAttribute('data-percent'));
      var start = Number(cashbackBox.getAttribute('data-start'));
      var end = Number(cashbackBox.getAttribute('data-end'));
      var revision = Number(cashbackBox.getAttribute('data-revision'));
      var now = Math.floor(Date.now() / 1000);
      return Boolean(cashbackBox.getAttribute('data-version') === '1' && cashbackBox.getAttribute('data-status') === 'ACTIVE' && cashbackBox.getAttribute('data-currency') === 'BRL' && cashbackBox.getAttribute('data-campaign-id') && Number.isInteger(revision) && revision > 0 && percent === 15 && Number.isInteger(start) && start > 0 && Number.isInteger(end) && (end === 0 || end > start) && now >= start && (end === 0 || now < end));
    }
    function updateCashback(priceCents) {
      if (!cashbackBox) return;
      if (cashbackTimer) clearTimeout(cashbackTimer);
      cashbackTimer = null;
      var active = cashbackWindowIsActive();
      var base = priceCents;
      active = active && cashbackAvailable && typeof base === 'number' && Number.isSafeInteger(base) && base >= 0 && base <= 99999999999;
      cashbackBox.hidden = !active;
      if (!active) return;
      var amount = cashbackBox.querySelector('[data-cashback-amount]');
      if (amount) {
        var percent = Number(cashbackBox.getAttribute('data-percent'));
        amount.textContent = money(Math.floor((base * percent + 50) / 100));
      }
      var end = Number(cashbackBox.getAttribute('data-end'));
      if (end > 0) {
        var remaining = Math.max(0, (end * 1000) - Date.now());
        cashbackTimer = setTimeout(function () { updateCashback(cashbackPrice); }, Math.min(2147483647, remaining));
      }
    }

    updateCashback(cashbackPrice);

    function selectedOptions() {
      var opts = [];
      scope.querySelectorAll('.pdp-opt-pills').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }
    function findVariant(opts) {
      if (!product) return null;
      /* Produto sem opções reais (variante única "Default Title") não renderiza pills,
         então opts vem vazio. Sem este atalho, o every() abaixo compara "Default Title"
         com undefined, não acha variante nenhuma e o botão vira "Indisponível" mesmo
         com estoque — foi o que aconteceu com carteiras e porta-cartões. */
      if (!opts.length) return product.variants[0] || null;
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function applyVariant(v) {
      if (!v) {
        var partial = false;
        scope.querySelectorAll('.pdp-opt-pills').forEach(function (fs) { if (!fs.querySelector('input:checked')) partial = true; });
        if (cashbackBox) {
          cashbackAvailable = partial;
          if (partial) updateCashback(cashbackPrice);
          else cashbackBox.hidden = true;
        }
        if (buyBtn) { buyBtn.disabled = true; buyBtn.textContent = partial ? 'Selecione o tamanho' : 'Indisponível'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      var target = flash && flash.kind === 'customerLive' ? flash.targets[String(v.id)] : flash && flash.targetPrice;
      var full = flash && flash.kind === 'customerLive' ? flash.bases[String(v.id)] : flash && flash.fullPrice;
      var bfPercent = superBlackIsReadyAndActive() && bfVariantMap ? Number(bfVariantMap[String(v.id)] || 0) : 0;
      if (bfNote) bfNote.hidden = !(bfPercent > 0);
      if (bfPercent > 0) {
        target = bfTargetCents(Number(v.price), Number(v.compare_at_price || 0), bfPercent);
        full = Math.max(Number(v.price), Number(v.compare_at_price || 0));
      }
      var displayPrice = target > 0 ? Math.min(v.price, target) : v.price;
      cashbackPrice = displayPrice;
      cashbackAvailable = Boolean(v.available);
      updateCashback(displayPrice);
      var displayCompare = full > displayPrice ? full : v.compare_at_price;
      var priceEl = scope.querySelector('[data-price]');
      var cmpEl = scope.querySelector('[data-compare]');
      var instEl = scope.querySelector('[data-inst]');
      if (priceEl) priceEl.textContent = money(displayPrice);
      if (cmpEl) {
        if (displayCompare && displayCompare > displayPrice) {
          cmpEl.textContent = money(displayCompare);
          cmpEl.style.display = '';
        } else cmpEl.style.display = 'none';
      }
      if (instEl) instEl.textContent = '8x de ' + money(Math.floor(displayPrice / 8)) + ' sem juros no cartão'; /* floor = mesmo arredondamento do Liquid (divided_by) */
      if (pixEl) {
        pixEl.hidden = primaryBfIsReadyAndActive();
        var pct = Number(pixEl.getAttribute('data-pix-pct') || 0);
        if (pct > 0) {
          var pix = Math.floor(displayPrice * (100 - pct) / 100);
          pixEl.lastChild.textContent = ' ' + money(pix) + ' no Pix (' + pct + '% off)';
        }
      }
      if (buyBtn) {
        buyBtn.disabled = !v.available;
        buyBtn.textContent = v.available ? buyLabel : 'Esgotado';
      }
      if (lowstockEl) {
        var q = v.inventory_quantity;
        var managed = v.inventory_management || (typeof q === 'number' && q > 0);
        if (v.available && managed && typeof q === 'number' && q > 0 && q <= 3) {
          lowstockEl.textContent = 'Restam poucas unidades neste tamanho.';
          lowstockEl.hidden = false;
        } else lowstockEl.hidden = true;
      }
      if (bis) bis.hidden = v.available;
      if (stickyPrice) stickyPrice.textContent = money(displayPrice);
      if (stickySelect) stickySelect.value = String(v.id);
      /* legenda da opção */
      scope.querySelectorAll('.pdp-opt-pills').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        var cur = fs.querySelector('[data-opt-current]');
        if (checked && cur) cur.textContent = checked.value;
      });
    }

    /* Risca as opções sem estoque, considerando o que já está selecionado nas outras
       opções. O Liquid marca o estado inicial; isto mantém correto quando o cliente
       troca de cor e o conjunto de tamanhos disponíveis muda. */
    function refreshPills() {
      if (!product) return;
      var sel = selectedOptions();
      scope.querySelectorAll('.pdp-opt-pills').forEach(function (fs) {
        var i = Number(fs.getAttribute('data-opt-index'));
        fs.querySelectorAll('[data-opt-input]').forEach(function (input) {
          var ok = product.variants.some(function (v) {
            if (!v.available || v.options[i] !== input.value) return false;
            return sel.every(function (s, j) { return j === i || !s || v.options[j] === s; });
          });
          var pill = input.closest('.pill');
          if (pill) pill.classList.toggle('off', !ok);
        });
      });
    }

    scope.querySelectorAll('[data-opt-input]').forEach(function (input) {
      input.addEventListener('change', function () { refreshPills(); applyVariant(findVariant(selectedOptions())); });
    });
    scope.querySelectorAll('.pdp-opt-pills').forEach(function (fs) {
      var checked = fs.querySelector('input:checked');
      var cur = fs.querySelector('[data-opt-current]');
      if (checked && cur) cur.textContent = checked.value;
    });

    document.addEventListener('mb:bf-phase-change', function () { applyVariant(findVariant(selectedOptions())); });
    document.addEventListener('mb:bf-variant-map-ready', function () { applyVariant(findVariant(selectedOptions())); });

    /* Estado inicial da variante. Sem isto, applyVariant só rodava no 'change':
       produto de opção única já marcada pelo Liquid (ex.: atacador, Tamanho 130cm)
       nunca dispara o evento, o campo id fica vazio e o botão trava em
       "Selecione o tamanho" — impossível comprar. Chamar aqui é seguro para os demais:
       com seleção incompleta, applyVariant mantém o botão desabilitado, como deve. */
    refreshPills();
    applyVariant(findVariant(selectedOptions()));

    /* sticky bar */
    var sticky = scope.querySelector('[data-sticky-atc]');
    if (sticky && form && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      var sio = new IntersectionObserver(function (es) {
        sticky.classList.toggle('show', !es[0].isIntersecting && es[0].boundingClientRect.top < 0);
      }, { threshold: 0 });
      sio.observe(form);

      if (stickySelect) {
        stickySelect.addEventListener('change', function () {
          var v = product.variants.find(function (x) { return String(x.id) === stickySelect.value; });
          if (!v) return;
          /* sincroniza pills */
          v.options.forEach(function (val, i) {
            var fs = scope.querySelector('.pdp-opt-pills[data-opt-index="' + i + '"]');
            if (fs) {
              var input = Array.prototype.find.call(fs.querySelectorAll('input'), function (inp) { return inp.value === val; });
              if (input) input.checked = true;
            }
          });
          applyVariant(v);
        });
      }
      var stickyAdd = scope.querySelector('[data-sticky-add]');
      if (stickyAdd) {
        stickyAdd.addEventListener('click', function () {
          var vid = stickySelect ? Number(stickySelect.value) : Number(idInput.value);
          if (!vid) { var fs0 = scope.querySelector('.pdp-opt-pills'); if (fs0) fs0.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
          stickyAdd.textContent = '…';
          var stickyRequest = flash
            ? addFlashItem(vid, 1, flash.variantCodes && flash.variantCodes[String(vid)], flash)
            : fetch(root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: vid, quantity: 1 })
              })
                .then(function (r) { if (!r.ok) throw new Error(); return fetch(root + 'cart.js'); })
                .then(function (r) { return r.json(); });
          stickyRequest
            .then(function (cart) {
              setCartCount(cart.item_count);
              stickyAdd.textContent = '✓';
              if (flash) window.location.assign(root + 'cart');
              else setTimeout(function () { stickyAdd.textContent = 'Adicionar'; }, 1600);
            })
            .catch(function () { stickyAdd.textContent = 'Erro'; setTimeout(function () { stickyAdd.textContent = 'Adicionar'; }, 1600); });
        });
      }
    }

    /* cores irmãs via predictive search */
    var sibs = scope.querySelector('[data-siblings]');
    if (sibs) {
      var modelKey = sibs.getAttribute('data-model');
      var modelTag = sibs.getAttribute('data-model-tag');
      var current = sibs.getAttribute('data-current');
      var norm = function (s) { return String(s).toLowerCase().replace(/[^a-z0-9]+/g, ''); };

      /* A rota por TAG e deterministica; o search/suggest.json NAO e.
         Medido em 12/09/2026: 'title:Sanhaco title:06' devolveu o Sanhaco 06 Cafe
         em apenas 3 de 12 consultas identicas — por isso a cor sumia da regua.
         /collections/all/<tag>?view=cores devolve sempre as 3. Sem a tag model:*
         (53 de 516 produtos ativos) cai na busca, como era antes. */
      function porTag() {
        if (!modelTag) return Promise.reject();
        return fetch(root + 'collections/all/' + encodeURIComponent(modelTag) + '?view=cores')
          .then(function (r) { return r.json(); })
          .then(function (arr) {
            return (arr || []).map(function (p) {
              return { handle: p.handle, title: p.title, url: p.url, image: p.image || '' };
            });
          });
      }
      function porBusca() {
        return fetch(root + 'search/suggest.json?q=' + encodeURIComponent(modelKey) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var ps = (data.resources && data.resources.results && data.resources.results.products) || [];
            return ps.filter(function (p) { return norm(p.title).indexOf(norm(modelKey)) !== -1; })
              .map(function (p) {
                return {
                  handle: p.handle || (p.url || '').split('?')[0].replace(/\/+$/, '').split('/').pop(),
                  title: p.title, url: p.url,
                  image: (p.featured_image && p.featured_image.url) || p.image || ''
                };
              });
          });
      }
      porTag()
        .catch(porBusca)
        .then(function (ps) { return (ps && ps.length >= 2) ? ps : porBusca(); })
        .then(function (prods) {
          if (!prods || prods.length < 2) { sibs.remove(); return; }
          var row = sibs.querySelector('[data-siblings-row]');
          var nameEl = sibs.querySelector('[data-sib-name]');
          prods.forEach(function (p) {
            var phandle = p.handle || (p.url || '').split('?')[0].replace(/\/+$/, '').split('/').pop();
            var isCur = phandle === current;
            var a = document.createElement('a');
            a.href = p.url;
            if (flash && flash.kind === 'customerLive' && flash.handles && flash.handles.indexOf(phandle) !== -1) {
              a.href = root + 'collections/' + flash.campaign + '/products/' + encodeURIComponent(phandle);
            }
            a.className = isCur ? 'cur' : '';
            a.title = p.title;
            var img = document.createElement('img');
            var rawUrl = p.image || '';
            if (!rawUrl) { return; }
            if (rawUrl.indexOf('//') === 0) rawUrl = 'https:' + rawUrl;
            img.src = rawUrl + (rawUrl.indexOf('?') > -1 ? '&' : '?') + 'width=200';
            img.onerror = function () {
              if (img.src.indexOf('width=200') > -1) { img.src = rawUrl; }
              else { a.remove(); }
            };
            img.alt = p.title;
            img.loading = 'lazy';
            a.appendChild(img);
            row.appendChild(a);
            if (isCur && nameEl) {
              var ti = p.title.toLowerCase().indexOf(modelKey.toLowerCase());
              var color = ti >= 0 ? p.title.slice(ti + modelKey.length) : '';
              color = color.replace(/^\s*[A-Z](?=\s)/, '').trim();
              var cw = color.split(/\s+/).filter(Boolean);
              if (cw.length > 2) color = cw[cw.length - 1];
              if (color) nameEl.textContent = color;
            }
          });
        })
        .catch(function () { sibs.remove(); });
    }

    /* avise-me quando voltar */
    if (bis) {
      var bisBtn = bis.querySelector('[data-bis-submit]');
      bisBtn.addEventListener('click', function () {
        var email = bis.querySelector('[data-bis-email]').value.trim();
        var msg = bis.querySelector('[data-bis-msg]');
        if (!/^\S+@\S+\.\S+$/.test(email)) { msg.textContent = 'Digite um e-mail válido.'; return; }
        bisBtn.disabled = true;
        fetch(bis.getAttribute('data-api'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            email: email,
            product_id: product ? product.id : null,
            variant_id: idInput ? Number(idInput.value) : null,
            product_title: product ? product.title : document.title,
            product_handle: product ? product.handle : null
          })
        })
          .then(function (r) {
            msg.textContent = r.ok ? '✓ Pronto! Te avisamos assim que voltar.' : 'Não foi possível cadastrar. Tenta de novo.';
          })
          .catch(function () { msg.textContent = 'Não foi possível cadastrar. Tenta de novo.'; })
          .finally(function () { bisBtn.disabled = false; });
      });
    }
  }

  /* ============ CARRINHO ============ */
  var cartPg = document.querySelector('[data-cart]');
  if (cartPg) initCart(cartPg);

  function initCart(scope) {
    function refresh(cart) {
      setCartCount(cart.item_count);
      var pageCount = scope.querySelector('[data-cart-page-count]');
      var itemCount = scope.querySelector('[data-cart-item-count]');
      var itemUnit = scope.querySelector('[data-cart-item-unit]');
      if (pageCount) pageCount.textContent = cart.item_count;
      if (itemCount) itemCount.textContent = cart.item_count;
      if (itemUnit) itemUnit.textContent = cart.item_count === 1 ? 'item' : 'itens';
      var sub = scope.querySelector('[data-subtotal]');
      var tot = scope.querySelector('[data-total]');
      var inst = scope.querySelector('[data-installment]');
      var before = scope.querySelector('[data-cart-before]');
      if (sub) sub.textContent = money(cart.items_subtotal_price);
      if (tot) tot.textContent = money(cart.total_price);
      if (before && typeof cart.original_total_price === 'number') before.textContent = money(cart.original_total_price);
      if (inst) inst.textContent = money(Math.floor(cart.total_price / 8)) + '/mês';
      cart.items.forEach(function (item, i) {
        var line = i + 1;
        var qtyEl = scope.querySelector('[data-line-qty="' + line + '"]');
        var prEl = scope.querySelector('[data-line-price="' + line + '"]');
        if (qtyEl) qtyEl.value = item.quantity;
        if (prEl) {
          var finalEl = prEl.querySelector('[data-line-final]');
          var originalEl = prEl.querySelector('[data-line-original]');
          if (finalEl) finalEl.textContent = money(item.final_line_price);
          else prEl.textContent = money(item.final_line_price);
          if (item.original_line_price > item.final_line_price && !originalEl) {
            originalEl = document.createElement('s');
            originalEl.setAttribute('data-line-original', '');
            prEl.insertBefore(originalEl, finalEl || prEl.firstChild);
          }
          if (originalEl) {
            if (item.original_line_price > item.final_line_price) originalEl.textContent = money(item.original_line_price);
            else originalEl.remove();
          }
        }
      });
      if (window.MbBfProgressiveCart) window.MbBfProgressiveCart.refresh(scope, cart);
      /* barra de frete grátis */
      var fs = scope.querySelector('[data-fs]');
      if (fs) {
        var threshold = Number(fs.getAttribute('data-threshold'));
        var msg = fs.querySelector('[data-fs-msg]');
        var fill = fs.querySelector('[data-fs-fill]');
        /* mede o subtotal de produtos, nao o total pos-desconto: senao um desconto
           (ex.: Pix) derruba o valor abaixo do minimo e a barra volta a dizer "faltam X" */
        var base = cart.items_subtotal_price;
        var truck = fs.querySelector('[data-fs-truck]');
        if (base >= threshold) {
          fs.classList.add('is-ok');
          msg.className = 'fs-msg ok';
          msg.innerHTML = 'Você ganhou <strong>frete grátis</strong> (Sul e Sudeste)';
        } else {
          fs.classList.remove('is-ok');
          msg.className = 'fs-msg';
          msg.innerHTML = 'Faltam <strong>' + money(threshold - base) + '</strong> para o frete grátis (Sul e Sudeste)';
        }
        var pct = Math.min(100, base * 100 / threshold);
        if (fill) fill.style.width = pct + '%';
        if (truck) truck.style.left = pct + '%';
      }
      if (cart.item_count === 0) location.reload();
    }

    scope._mbCartRefresh = refresh;

    function changeLine(line, qtyVal) {
      scope.classList.add('cart-busy');
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qtyVal })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (qtyVal === 0) { location.reload(); return; }
          refresh(cart);
        })
        .catch(function () {
          if (window.MbBfProgressiveCart) window.MbBfProgressiveCart.showError(scope);
          else location.reload();
        })
        .finally(function () { scope.classList.remove('cart-busy'); });
    }

    scope.querySelectorAll('[data-cart-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var line = Number(b.getAttribute('data-line-i'));
        var qtyEl = scope.querySelector('[data-line-qty="' + line + '"]');
        var next = Math.max(0, Number(qtyEl.value) + Number(b.getAttribute('data-cart-qty')));
        changeLine(line, next);
      });
    });
    scope.querySelectorAll('[data-remove]').forEach(function (b) {
      b.addEventListener('click', function () { changeLine(Number(b.getAttribute('data-remove')), 0); });
    });

    /* nota do pedido (salva ao digitar) */
    var note = scope.querySelector('textarea[name="note"]');
    if (note) {
      var noteTimer;
      note.addEventListener('input', function () {
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () {
          fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: note.value })
          }).catch(function () {});
        }, 600);
      });
    }

    /* cupom */
    var dBtn = scope.querySelector('[data-discount-apply]');
    if (dBtn) {
      dBtn.addEventListener('click', function () {
        var code = scope.querySelector('[data-discount-code]').value.trim();
        if (code) window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=/cart';
      });
    }

    /* calculadora de frete */
    var calcBtn = scope.querySelector('[data-cep-calc]');
    if (calcBtn) {
      var cepInput = scope.querySelector('[data-cep]');
      cepInput.addEventListener('input', function () {
        var v = cepInput.value.replace(/\D/g, '').slice(0, 8);
        cepInput.value = v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v;
      });
      calcBtn.addEventListener('click', function () {
        var zip = cepInput.value.replace(/\D/g, '');
        var out = scope.querySelector('[data-cep-results]');
        if (zip.length !== 8) { out.innerHTML = '<li class="err">CEP inválido: use 8 dígitos.</li>'; return; }
        out.innerHTML = '<li>Calculando…</li>';
        fetch(root + 'cart/shipping_rates.json?shipping_address%5Bzip%5D=' + zip + '&shipping_address%5Bcountry%5D=Brazil')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var rates = data.shipping_rates || [];
            if (!rates.length) { out.innerHTML = '<li class="err">Nenhuma opção encontrada para esse CEP.</li>'; return; }
            out.innerHTML = rates.map(function (rate) {
              var price = parseFloat(rate.price) === 0 ? 'Grátis' : 'R$ ' + parseFloat(rate.price).toFixed(2).replace('.', ',');
              var eta = rate.delivery_days && rate.delivery_days.length ? ' · até ' + rate.delivery_days[rate.delivery_days.length - 1] + ' dias úteis' : '';
              return '<li><span>' + rate.name + eta + '</span><b>' + price + '</b></li>';
            }).join('');
          })
          .catch(function () { out.innerHTML = '<li class="err">Não foi possível calcular agora. Confirme no checkout.</li>'; });
      });
    }
  }
})();

/* ===================== Busca estrita por título =====================
   A busca desta loja usa expansão semântica da Shopify: "orvalho" devolvia 208
   produtos, com Vento e Mergulhão no meio dos resultados. O prefixo `title:`
   desliga a expansão e procura só no título — orvalho 208->2, palmilha 218->2.
   (options[fields] não funciona aqui: é ignorado pela busca semântica.)

   Multi-palavra vira AND de títulos e pode zerar (ex.: "tenis trilha"); nesse
   caso a página cai sozinha de volta na busca ampla, uma única vez.
   Tudo client-side: sem JS o comportamento antigo continua valendo. */
(function () {
  var TERMO = 'mbq';   // termo que a pessoa digitou, para exibição e fallback
  var AMPLA = 'mbf';   // marca que já tentamos a busca ampla (evita loop)

  function estrita(v) {
    if (/[:"]/.test(v)) return null;                 // já usou sintaxe própria
    var t = v.trim().split(/\s+/).filter(Boolean);
    return t.length ? t.map(function (w) { return 'title:' + w; }).join(' ') : null;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/search') === -1) return;
    /* só o campo visível: o formulário de filtros usa um hidden name="q" que
       precisa continuar carregando a consulta já convertida. */
    var input = form.querySelector('input[type="search"][name="q"]');
    if (!input) return;
    var digitado = input.value;
    var q = estrita(digitado);
    if (!q) return;
    var hid = form.querySelector('input[name="' + TERMO + '"]');
    if (!hid) { hid = document.createElement('input'); hid.type = 'hidden'; hid.name = TERMO; form.appendChild(hid); }
    hid.value = digitado;
    input.value = q;
  }, true);

  var params = new URLSearchParams(location.search);
  var digitado = params.get(TERMO);
  if (!digitado) return;

  /* mostra o termo digitado, não a sintaxe interna — inclusive no title da aba */
  document.querySelectorAll('input[type="search"][name="q"]').forEach(function (i) { i.value = digitado; });
  if (document.title.indexOf('title:') !== -1) {
    document.title = document.title.replace(/title:\S+\s*/g, digitado + ' ').replace(/\s{2,}/g, ' ');
  }
  var rotulo = document.querySelector('.plp-count') || document.querySelector('.plp-empty');
  if (rotulo) rotulo.textContent = rotulo.textContent.replace(/“[^”]*”/, '“' + digitado + '”');

  /* estrita não achou nada -> refaz ampla com o termo original */
  var contador = document.querySelector('.plp-count');
  var vazio = !!document.querySelector('.plp-empty') ||
              /(^|\s)0\s+resultados?/.test((contador && contador.textContent) || '');
  if (vazio && !params.has(AMPLA)) {
    params.set('q', digitado);
    params.delete(TERMO);
    params.set(AMPLA, '1');
    location.replace(location.pathname + '?' + params.toString());
  }
})();
